const getUrlPath = (url: string): string => {
  const m = url.match(/^[a-z]+:\/\/[^/]+(\/.*)?$/)
  return (m && m[1]) || '/'
}

export default getUrlPath
